import { render, staticRenderFns } from "./SupplierQuotesShow.vue?vue&type=template&id=39c330ce&"
import script from "./SupplierQuotesShow.vue?vue&type=script&lang=js&"
export * from "./SupplierQuotesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports